import currency from 'currency.js';

const config = {
    decimal: '.',
    separator: ' ',
    symbol: '',
};

export const formatToCurrency = (
    amount: number | string,
    currencyPrecision: number,
    currencyTemplate = 'X',
): string => {
    const formattedValue = currency(amount, {
        ...config,
        precision: currencyPrecision,
    }).format();

    return currencyTemplate.replace('X', formattedValue);
};
